import { Flex, IconButton, Select } from '@driftt/dds'
import { faXmark } from '@driftt/dds.icons/solid/faXmark'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { OPERATORS_LIST } from 'components/AIConfiguration/LeadQualification/constants'
import { useAttributeValueFactory } from 'components/AIConfiguration/LeadQualification/PersonaCard/hooks'
import { PersonaForm } from 'components/AIConfiguration/LeadQualification/PersonaCard/types'

interface Props {
  idx: number
  disabled: boolean
  remove: (idx: number) => void
  canDelete: boolean
  attributeNameOptions: {
    label: string
    value: string
  }[]
}

const AttributeRow = ({
  idx,
  disabled,
  remove,
  canDelete,
  attributeNameOptions,
}: Props) => {
  const {
    watch,
    control,
    setValue,
    formState: { errors: { attributes: attributeErrors = {} } = {} },
  } = useFormContext<PersonaForm>()

  const operator = watch(`attributes.${idx}.operator`)

  const { component, validation, defaultValue } = useAttributeValueFactory(
    operator?.value
  )

  return (
    <Flex gap={1}>
      <Controller
        name={`attributes.${idx}.name`}
        control={control}
        rules={{ required: 'Attribute required' }}
        render={({ field: { value, onChange } }) => (
          <Select
            label="Attribute"
            options={attributeNameOptions}
            onChange={onChange}
            value={
              typeof value === 'string'
                ? {
                    label: value,
                    value,
                  }
                : value
            }
            isDisabled={disabled}
            error={attributeErrors[idx]?.name?.message}
          />
        )}
      />

      <Controller
        name={`attributes.${idx}.operator`}
        control={control}
        rules={{ required: 'Operator required' }}
        render={({ field: { value, onChange } }) => (
          <div title={value?.label}>
            <Select
              size="small"
              label="Condition"
              options={OPERATORS_LIST}
              onChange={(value) => {
                setValue(`attributes.${idx}.value`, '', {
                  shouldValidate: true,
                })
                onChange(value)
              }}
              value={value}
              isDisabled={disabled}
              error={attributeErrors[idx]?.operator?.message}
            />
          </div>
        )}
      />

      <Controller
        name={`attributes.${idx}.value`}
        control={control}
        rules={validation}
        render={({ field: { value, onChange } }) => {
          return component({
            disabled,
            onChange,
            error: attributeErrors[idx]?.value?.message,
            value: Boolean(value?.length) ? value : defaultValue,
          })
        }}
      />

      {canDelete && (
        <IconButton
          iconVariant="gray"
          css={{
            marginTop: '24px',
          }}
          title="remove attribute"
          icon={faXmark}
          onClick={() => remove(idx)}
          disabled={disabled}
        />
      )}
    </Flex>
  )
}

export default AttributeRow
